module.exports = __webpack_public_path__ + "static/img-cb95fb6a49212a28e59600e84b61b913.jpg";